import { useOnlineStatus } from "./use-online-status.js";
import { Alert } from "@evolua/ui";

export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <Alert tone="warning" className="evolua-offline-banner">
      Você está offline — mostrando dados em cache quando disponíveis.
    </Alert>
  );
}
